import Box from "@@/elements/Box";
import SkeletonBox from "@@/components/Loader/Skeleton";
import { Size } from "@@/hooks/ui/use-size";
import styles from "../styles.module.scss";
import cn from "classnames";

type Variant = "latestnews" | "newsmodule" | "relatedcontent" | "newslisting";

interface SkeletonProps {
  variant: Variant;
}

const VARIANT_IMAGE_HEIGHTS: Partial<Record<Variant, Size>> = {
  newslisting: [55, 40, 40],
  latestnews: [50, 80, 95],
  newsmodule: [50, 50, 80],
};

const SkeletonCard = ({ variant }: SkeletonProps) => {
  const skeletonImageHeight: Size = VARIANT_IMAGE_HEIGHTS[variant] ?? 70;
  const cardClassName = cn(styles.card, {
    [styles.card_full_width]: variant === "newslisting" || variant === "newsmodule",
  });
  return (
    <Box br={1} className={cardClassName}>
      <SkeletonBox width="full" height={skeletonImageHeight} />
      <Box width="full" pb={4} pt={6} px={6}>
        <SkeletonBox width={20} height={4} />
        <SkeletonBox mt={4} mr={6} width="full" height={14} />
      </Box>
    </Box>
  );
};

export default SkeletonCard;
